var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 2C8.29822 2 5.5 4.79822 5.5 8.25V10.75C4.11929 10.75 3 11.8693 3 13.25V19.5C3 20.8807 4.11929 22 5.5 22H18C19.3807 22 20.5 20.8807 20.5 19.5V13.25C20.5 11.8693 19.3807 10.75 18 10.75H8V8.25C8 6.17893 9.67893 4.5 11.75 4.5C13.4956 4.5 14.9656 5.6939 15.3819 7.31157C15.554 7.98014 16.2355 8.38262 16.9041 8.21055C17.5726 8.03847 17.9751 7.35699 17.803 6.68843C17.1093 3.99303 14.664 2 11.75 2Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleUnlock);
export default __webpack_public_path__ + "static/media/purple-unlock.65e01da416ca0c031cec78fd957ae5d6.svg";
export { ForwardRef as ReactComponent };